const MarketsEnum = [
  'Packaging',
  'Automotive',
  'Aerospace',
  'Transportation',
  'Defense',
  'Industry',
  'Building & Construction',
  'Additive Manufacturing',
]

export default MarketsEnum
